import { Component, OnInit } from "@angular/core";
import { Globals } from "../../common/global";

@Component({
  selector: "app-employee-dashboard",
  templateUrl: "./employee-dashboard.component.html",
  styleUrls: ["./employee-dashboard.component.css"],
})
export class EmployeeDashboardComponent implements OnInit {
  public name: string = "Pramod Dodiya";
  constructor(public globals: Globals) {}
  user: any = "";

  ngOnInit(): void {
    this.user = this.globals.getUser();
  }
}
